var _defs, _path, _rect, _rect2, _rect3, _rect4, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHorizontalRender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 350 160",
    id: "svg10",
    width: 350,
    height: 160,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs10"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f22834",
    d: "m 158.32054,62.834882 q 1.7,5.97 2.08,9.6 c 0.92,9.01 1.32,20.94 -1.46,30.339998 q -0.16,0.52 -0.7,0.52 H 8.3605411 q -0.26,0 -0.31,-0.26 c -0.65,-2.97 -1.51,-5.849998 -1.73,-8.859998 -0.93,-12.62 -0.63,-22.7 2.9299999,-33.7 7.19,-22.14 24.14,-41.3 46.36,-49.26 2.86,-1.03 5.66,-2.18 8.58,-2.84 11.6,-2.6 21.28,-3.13 32.54,-1.17 29.799999,5.19 53.279999,26.58 61.589999,55.63 z",
    id: "path1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#f22834",
    x: 14.070538,
    y: 111.62489,
    width: 138.86,
    height: 5.2800002,
    rx: 2.6199999,
    id: "rect1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#f22834",
    x: 21.370541,
    y: 123.13489,
    width: 124.14,
    height: 4.8400002,
    rx: 1.97,
    id: "rect2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#f22834",
    x: 35.120541,
    y: 134.15489,
    width: 96.599998,
    height: 4.7800002,
    rx: 2.26,
    id: "rect3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    fill: "#f22834",
    x: 56.280544,
    y: 145.17488,
    width: 54.580002,
    height: 5.1199999,
    rx: 2.53,
    id: "rect4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m 310.70098,65.973895 6.91,10.579997 a 0.33,0.33 0 0 1 0,0.36 l -6.2,9.49 a 0.33,0.33 0 0 1 -0.56,0 l -13.09,-19.909997 a 0.33,0.33 0 0 1 0.27,-0.51 l 12.39,-0.16 a 0.33,0.33 0 0 1 0.28,0.15 z",
    id: "path4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m 328.30098,93.203892 17.66,25.669998 a 0.32,0.32 0 0 1 -0.26,0.5 l -12.66,-0.02 a 0.32,0.32 0 0 1 -0.26,-0.14 l -17.71,-26.309998 a 0.32,0.32 0 0 1 0,-0.36 l 17.64,-26.309997 a 0.32,0.32 0 0 1 0.26,-0.14 l 12.65,-0.11 a 0.32,0.32 0 0 1 0.26,0.5 l -17.58,26.359997 a 0.32,0.32 0 0 0 0,0.36 z",
    id: "path5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m 182.95098,91.823892 0.05,11.759998 q 0,0.25 -0.25,0.25 h -4.48 q -0.22,0 -0.22,-0.23 l -0.02,-20.049998 q 0,-0.59 0.6,-0.6 1.59,0 3.1,-0.01 c 2.39,-0.01 1.94,1.21 2.92,2.68 q 3.38,5.12 6.52,9.89 a 0.34,0.34 0 0 0 0.62,-0.18 l -0.02,-12.01 q 0,-0.37 0.37,-0.37 h 3.99 a 0.37,0.37 0 0 1 0.37,0.37 v 20.009998 q 0,0.51 -0.5,0.51 h -3.84 q -0.55,0 -0.85,-0.47 l -7.62,-11.769998 q -0.75,-1.16 -0.74,0.22 z",
    id: "path6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m 234.64098,93.353892 a 10.71,10.71 0 0 1 -10.71,10.709998 10.71,10.71 0 0 1 -10.71,-10.709998 10.71,10.71 0 0 1 10.71,-10.71 10.71,10.71 0 0 1 10.71,10.71 z m -5.2263,-0.9938 a 4.98,4.98 0 0 0 -4.91,-5.0491 l -0.9399,-0.0131 a 4.98,4.98 0 0 0 -5.049,4.91 l -0.0285,2.0398 a 4.98,4.98 0 0 0 4.91,5.0491 l 0.9399,0.0131 a 4.98,4.98 0 0 0 5.049,-4.91 z",
    id: "path7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m 284.62098,83.353892 a 0.39,0.39 0 0 1 0.39,-0.39 l 7.45,0.02 a 10.86,10.19 0.2 0 1 10.82,10.23 v 0.48 a 10.86,10.19 0.2 0 1 -10.9,10.149998 l -7.45,-0.02 a 0.39,0.39 0 0 1 -0.38,-0.39 z m 5.01,3.89 v 12.34 a 0.43,0.43 0 0 0 0.43,0.429998 h 2.24 a 5.67,5.47 0 0 0 5.67,-5.469998 v -2.26 a 5.67,5.47 0 0 0 -5.67,-5.47 h -2.24 a 0.43,0.43 0 0 0 -0.43,0.43 z",
    id: "path8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m 263.04098,95.023892 a 0.56,0.57 64 0 0 -0.29,0.83 l 4.75,7.689998 a 0.17,0.17 0 0 1 -0.14,0.26 l -5.32,0.05 q -0.31,0.01 -0.47,-0.26 l -4.33,-7.519998 a 0.53,0.52 30.1 0 0 -0.98,0.26 l -0.01,7.249998 a 0.25,0.25 0 0 1 -0.25,0.25 l -4.31,0.01 q -0.32,0 -0.32,-0.32 l -0.05,-19.949998 q 0,-0.51 0.51,-0.52 c 2.99,-0.07 7.57,-0.25 9.56,0.04 6.56,0.95 8.39,9.4 1.65,11.93 z m -6.78,-7.84 -0.02,4.28 a 0.35,0.35 0 0 0 0.35,0.36 l 3.21,0.01 a 2.2,2.22 0.3 0 0 2.21,-2.2 v -0.54 a 2.2,2.22 0.3 0 0 -2.19,-2.24 l -3.21,-0.01 a 0.35,0.35 0 0 0 -0.35,0.34 z",
    id: "path9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m 297.56098,118.68389 13.24,-19.639998 a 0.34,0.34 0 0 1 0.57,0.01 l 6.14,9.339998 a 0.34,0.34 0 0 1 0,0.38 l -6.8,10.29 a 0.34,0.34 0 0 1 -0.28,0.15 h -12.59 a 0.34,0.34 0 0 1 -0.28,-0.53 z",
    id: "path10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalRender);
export default __webpack_public_path__ + "static/media/horizontal_render.0cd37737e0c9689be79758a1c9894f8b.svg";
export { ForwardRef as ReactComponent };